import { useMemo } from 'react';
import type { Country } from '@viet-parenting/supabase/types';
import Combobox, { type ComboboxOption } from './Combobox';

interface Props {
  /** Selected ISO country code, or '' when nothing is picked yet. */
  value: string;
  onChange: (code: string) => void;
  countries: ReadonlyArray<Country>;
  disabled?: boolean;
  className?: string;
}

/** Country picker: search by Vietnamese name, English name or ISO code. */
export default function CountryCombobox({
  value,
  onChange,
  countries,
  disabled,
  className,
}: Props) {
  const options = useMemo<ComboboxOption[]>(
    () =>
      countries.map((c) => ({
        value: c.code,
        label: `${c.flag} ${c.name_vi} — ${c.name_en} (${c.code})`,
        keywords: c.slug,
      })),
    [countries],
  );

  return (
    <Combobox
      value={value}
      onChange={onChange}
      options={options}
      disabled={disabled}
      placeholder="Gõ để tìm quốc gia…"
      emptyLabel="Không tìm thấy quốc gia."
      className={className}
    />
  );
}
